import React, { useState, useEffect } from "react";

import Form from "@Components/Form";
import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";

const detailURL = "/configuration/get-config/";

const TranslationCountSetting = () => {
  const [loading, setLoading] = useState(false);
  const [translationCountLimit, setTranslationCountLimit] = useState(0);
  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.translation_count_limit) {
            setTranslationCountLimit(response.data.translation_count_limit);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };
  const initialValues = { translation_count_limit: translationCountLimit };

  useEffect(() => {
    fetchDetails();
  }, [translationCountLimit]);

  const formFields = [
    {
      name: "translation_count_limit",
      type: "input",
      label: "Max. Translation Count Limit",
      color: "primary",
      required: true,
      size: "medium",
      value: translationCountLimit,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "cancel",
      label: "Cancel",
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, values)
      .then(() => {
        setTranslationCountLimit(values["translation_count_limit"]);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setSubmitting(false);
        setLoading(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading(false);
      });
  };

  return (
    <Form
      initialValues={initialValues}
      outerSubmitHandler={handleSubmit}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Translation Count Setting"
    />
  );
};

export default TranslationCountSetting;
